import { render, staticRenderFns } from "./BonusPointForm.template.vue?vue&type=template&id=6e730113&scoped=true&"
var script = {}
import style0 from "./BonusPointForm.template.vue?vue&type=style&index=0&id=6e730113&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e730113",
  null
  
)

export default component.exports